module.exports = __webpack_public_path__ + "img/me_user.ab466525.svg";